import React, { FC } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PrivateRoute } from 'routes/PrivateRoute';
import { UsersList } from 'features/Users/UsersList';
import { AppMenuDrawer } from 'components/AppMenu/AppMenuDrawer';
import { SimpleNavBar } from 'components/NavBar/SimpleNavBar';
import { ManageCompanyRedirects } from './ManageCompanyRedirects';
import { SwitchCatchNotFound as Switch } from './SwitchCatchNotFound';
import { profilePrefix } from './routes';

const UsersRoutes: FC<{}> = () => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();
  return (
    <>
      <AppMenuDrawer />
      <ManageCompanyRedirects redirectTo={profilePrefix} />
      <Switch>
        <PrivateRoute
          exact
          path={path}
          component={UsersList}
          navbar={SimpleNavBar}
          navbarTitle={t('delegates.title')}
        />
      </Switch>
    </>
  );
};

export { UsersRoutes };
